import { Button, ColourStateSolid } from '@ukpostbox/frontend-framework';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { SignUpSectionHeaderType } from '../Types/SignUp/SignUpSectionType';

function SignUpSectionHeader(props: SignUpSectionHeaderType) {
	return (
		<div
			className={`sign-up-section-header mb-sm ${props.complete && !props.visible ? 'sign-up-section-header-complete' : ''}`}
		>
			{props.visible && <h4 className='m-0'>{props.label}</h4>}

			{props.complete && !props.visible && (
				<>
					<div className='flex-row align-center'>
						<div className='mr-xs'>
							<FontAwesomeIcon icon={faCheckCircle} size='2x' />
						</div>
						<div>
							<h6 className='fade m-0'>{props.label}</h6>
							<h3 className='m-0'>{props.completeLabel}</h3>
						</div>
					</div>
					<Button title='Edit' onClick={props.editCallBack} colour={ColourStateSolid.Text} />
				</>
			)}
		</div>
	);
}

export default SignUpSectionHeader;
